/* eslint-disable no-plusplus */
/* eslint-disable no-case-declarations */
import { TopicAnalysisStatus } from '../../../enum';

// eslint-disable-next-line complexity, max-statements
const TopicReducer = (state, action) => {
  const daysSinceEndDate = Math.abs(
    (new Date(action?.engagementSummary?.endTime || '').getTime() -
      new Date(action?.createdAt).getTime()) /
      (1000 * 3600 * 24)
  );
  switch (action.type) {
    case 'load':
      const bCanTopicAnalysis =
        action?.classifications?.includes('open-ended') &&
        action?.classifications?.includes('qualitative');
      const newSummary = action?.payload;
      const bHasTopicSummary = newSummary && newSummary.topics && newSummary.topics.length > 0;
      const returnedTopicState = {
        topicSummary: newSummary,
        filters: '',
        expanded: [],
      };
      // if has no topics and will not run analysis
      if (!bCanTopicAnalysis && !bHasTopicSummary) {
        returnedTopicState.topicSummary.status = TopicAnalysisStatus.NEVER;
        returnedTopicState.topicSummary.tags = action?.classifications;
        return returnedTopicState;
      }
      // engagement is not open yet
      if (
        (!returnedTopicState.topicSummary.topics ||
          returnedTopicState.topicSummary.topics.length === 0) &&
        (!action?.engagementSummary?.startTime ||
          new Date(action?.engagementSummary?.startTime).getTime() > Date.now())
      ) {
        returnedTopicState.topicSummary.status = TopicAnalysisStatus.ENGAGEMENT_PRE_OPEN;
        return returnedTopicState;
      }
      // engagement is still open
      if (
        (!returnedTopicState.topicSummary.topics ||
          returnedTopicState.topicSummary.topics.length === 0) &&
        (!action?.engagementSummary?.endTime ||
          new Date(action?.engagementSummary?.endTime).getTime() > Date.now())
      )
        if (!returnedTopicState.topicSummary) {
          // edge case topic analysis doesn't exist
          returnedTopicState.topicSummary = { status: TopicAnalysisStatus.NONE };
          return returnedTopicState;
        }
      // engagement is still open
      if (
        !action?.engagementSummary?.endTime ||
        new Date(action?.engagementSummary?.endTime).getTime() >
          new Date(action?.createdAt).getTime()
      ) {
        returnedTopicState.topicSummary.status = TopicAnalysisStatus.ENGAGEMENT_OPEN;
        return returnedTopicState;
      }
      // no result (and engagment end date is defined or was closed more then 3 days ago)
      if (
        (!returnedTopicState.topicSummary.topics ||
          returnedTopicState.topicSummary.topics.length === 0) &&
        (returnedTopicState.topicSummary.runOn || daysSinceEndDate > 3)
      ) {
        returnedTopicState.topicSummary.status = TopicAnalysisStatus.EMPTY;
        return returnedTopicState;
      }
      // no result (pending processing)
      if (
        !returnedTopicState.topicSummary.topics ||
        returnedTopicState.topicSummary.topics.length === 0
      ) {
        returnedTopicState.topicSummary.status = TopicAnalysisStatus.PENDING;
        return returnedTopicState;
      }

      // success we have topic analysis data
      returnedTopicState.topicSummary.status = TopicAnalysisStatus.SUCCESS;
      returnedTopicState.topicSummary.runOn =
        returnedTopicState.topicSummary.runOn || action?.engagementSummary?.endTime;

      // edge case if we have only 1 subtopic for a given topic remove the subtopic to only show the topic.
      for (let topicIt = 0; topicIt < returnedTopicState?.topicSummary?.topics?.length; ++topicIt) {
        const objTopic = returnedTopicState.topicSummary.topics[topicIt];
        if (objTopic?.subtopics && objTopic?.subtopics?.length <= 1) {
          objTopic.subtopics = undefined;
        }
      }
      return returnedTopicState;
    /**
     * // disabled for summary
    case 'select':
      if (state.filters === action.payload) {
        return { ...state, filters: '', filterType: action.filterType };
      }
      return { ...state, filters: action.payload, filterType: action.filterType };
    */
    case 'toggleExpand':
      const cloneExpand = JSON.parse(JSON.stringify(state.expanded));
      if (action.payload && typeof action.payload === 'string') {
        const topicIndex = cloneExpand.indexOf(action.payload);
        if (topicIndex < 0) {
          cloneExpand.push(action.payload);
        } else {
          cloneExpand.splice(topicIndex, 1);
        }
      }
      return { ...state, expanded: cloneExpand };
    case 'expandAll':
      const allTopics = [];
      (state.topicSummary.topics || []).forEach((topic) => {
        if (topic.subtopics && topic.subtopics.length > 0) {
          allTopics.push(topic.name);
        }
      });
      return { ...state, expanded: allTopics };
    case 'collapseAll':
      return { ...state, expanded: [] };
    default:
      return state;
  }
};

export default TopicReducer;
